import { useEffect, useState } from 'react';

const getRuntimeConfig = () => {
  if (typeof window !== 'undefined' && window.__ENV__) {
    return window.__ENV__;
  }

  return {};
};

const getValueFromSource = (source, key) => {
  if (!source || typeof source !== 'object') {
    return '';
  }

  const directValue = source[key];
  if (typeof directValue === 'string' && directValue.trim() !== '') {
    return directValue;
  }

  const normalizedKey = key.startsWith('REACT_APP_') ? key.replace(/^REACT_APP_/, '') : `REACT_APP_${key}`;
  const normalizedValue = source[normalizedKey];
  if (typeof normalizedValue === 'string' && normalizedValue.trim() !== '') {
    return normalizedValue;
  }

  return '';
};

export function getEnvValue(key, fallback = '') {
  const runtimeConfig = getRuntimeConfig();
  const runtimeValue = getValueFromSource(runtimeConfig, key);
  if (runtimeValue) {
    return runtimeValue;
  }

  const processValue = getValueFromSource(process.env, key);
  if (processValue) {
    return processValue;
  }

  return fallback;
}

export function useEnvValue(key, fallback = '') {
  const [value, setValue] = useState(() => getEnvValue(key, fallback));

  useEffect(() => {
    setValue(getEnvValue(key, fallback));
  }, [key, fallback]);

  return value;
}
